// Kept in memory only: a full page load always starts from the browser language.
let chosenLanguage = null;

export const detectBrowserLanguage = () => {
  const langs = navigator.languages?.length ? navigator.languages : [navigator.language || navigator.userLanguage || 'en'];
  return langs[0].toLowerCase().startsWith('es') ? 'es' : 'en';
};

export const getInitialLanguage = () => chosenLanguage || detectBrowserLanguage();

const SEO_META = {
  en: {
    title: 'PaymentPower - White-label Payment Gateway Solution',
    description: 'PaymentPower: Complete white-label payment gateway for fintech startups, PayFacs & banks. Process payments in 150+ currencies with AI-powered fraud protection, intelligent routing & full customization. Start your payment platform today.',
    locale: 'en_US',
    altLocale: 'es_ES',
  },
  es: {
    title: 'PaymentPower - Pasarela de Pagos Marca Blanca',
    description: 'PaymentPower: Pasarela de pagos marca blanca para fintechs, facilitadores de pago y bancos. Procesa pagos en más de 150 monedas con protección antifraude con IA, enrutamiento inteligente y personalización total. Lanza tu plataforma de pagos hoy.',
    locale: 'es_ES',
    altLocale: 'en_US',
  },
};

export const applyLanguage = (language) => {
  chosenLanguage = language;
  document.documentElement.lang = language;
  const seo = SEO_META[language];
  document.title = seo.title;
  const setMeta = (selector, value) => document.querySelector(selector)?.setAttribute('content', value);
  setMeta('meta[name="description"]', seo.description);
  setMeta('meta[property="og:title"]', seo.title);
  setMeta('meta[property="og:description"]', seo.description);
  setMeta('meta[name="twitter:title"]', seo.title);
  setMeta('meta[name="twitter:description"]', seo.description);
  setMeta('meta[property="og:locale"]', seo.locale);
  setMeta('meta[property="og:locale:alternate"]', seo.altLocale);
};
